import { WithObsTypeAndParams } from "../api/EvalWorkflowApi";
import { ParamType } from "../api/GrammarApi";

export function getElementsWithUnfilledParams<T extends WithObsTypeAndParams>(
  elements: T[],
  paramTypesByObsTypes: Record<string, ParamType[]>
): T[] {
  return elements.filter((element) => {
    const { obsType } = element;
    const paramTypes = paramTypesByObsTypes[obsType] || [];

    return paramTypes
      .filter((paramType) => paramType.required)
      .some((paramType) => !element.valueByParam?.[paramType.code]);
  });
}
